import { render, staticRenderFns } from "./CustomerReportSubCategory.vue?vue&type=template&id=2a99862d"
import script from "./CustomerReportSubCategory.vue?vue&type=script&lang=js"
export * from "./CustomerReportSubCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports